<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

    <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
       <label>Código</label>
       <b-form-input type="text"
                     placeholder="Código"
                     v-model="form.cd"
                     name="cd"
                     >
       </b-form-input>
       <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

       <label>Descrição</label>
       <b-form-input type="text"
                     placeholder="Descrição"
                     v-model="form.descr"
                     name="descr"
                     >
       </b-form-input>
       <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

       <label>Status</label>
       <multiselect v-model="statusSelected"
       :options="optionsLivStatus"
       track-by="value"
       label="label"
       :hide-selected="true"
       placeholder="Selecione"
       tag-placeholder="Selecionar"
       select-label="Selecionar"
       selected-label="Selecionado"
       deselect-label="Remover"
       ></multiselect>
       <b-form-feedback v-text="form.errors.get('status.value')" v-if="form.errors.has('status.value')"></b-form-feedback>

       <label>Tipo Conta</label>
       <multiselect v-model="tpContaSelected"
       :options="optionsLivTipoConta"
       track-by="value"
       label="label"
       :hide-selected="true"
       placeholder="Selecione"
       tag-placeholder="Selecionar"
       select-label="Selecionar"
       selected-label="Selecionado"
       deselect-label="Remover"
       ></multiselect>
       <b-form-feedback v-text="form.errors.get('tp_conta.value')" v-if="form.errors.has('tp_conta.value')"></b-form-feedback>

       <label>Tipo Operação</label>
       <multiselect v-model="tpOperacaoSelected"
       :options="optionsLivTipoOperacao"
       track-by="value"
       label="label"
       :hide-selected="true"
       placeholder="Selecione"
       tag-placeholder="Selecionar"
       select-label="Selecionar"
       selected-label="Selecionado"
       deselect-label="Remover"
       ></multiselect>
       <b-form-feedback v-text="form.errors.get('tp_operacao.value')" v-if="form.errors.has('tp_operacao.value')"></b-form-feedback>

       <label>Conta Pai</label>
       <multiselect v-model="conconPaiSelected"
       :options="optionsLivConconPai"
       track-by="value"
       label="label"
       :hide-selected="true"
       placeholder="Selecione"
       tag-placeholder="Selecionar"
       select-label="Selecionar"
       selected-label="Selecionado"
       deselect-label="Remover"
       ></multiselect>
       <b-form-feedback v-text="form.errors.get('concon_id_pai.value')" v-if="form.errors.has('concon_id_pai.value')"></b-form-feedback>

    </form>
          <div slot="modal-footer" class="w-100">
                 <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                 <div class="float-right">
                     <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                     <b-btn @click="showModal=false" variant="secondary">
                       Fechar
                     </b-btn>
                     <b-btn @click="handleOk($event)" variant="primary" :disabled="isDisabled">
                       Enviar
                     </b-btn>
                 </div>
          </div>
      </b-modal>

</template>
<script>
import AvisoErros from '../components/AvisoErros'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalGrupo: false,
        isLoadingPessoa: false,
        optionsLivStatus: [],
        optionsLivTipoConta: [],
        optionsLivTipoOperacao: [],
        optionsLivConconPai: [],
        statusSelected: [],
        tpContaSelected: [],
        tpOperacaoSelected: [],
        conconPaiSelected: [],
        errors_array: [],
        helpForm: new Form({
            statusRecord: [],
            params: []
        }),
        form: new Form({
            cd: '',
            descr: '',
            status: '',
            tp_operacao: '',
            tp_conta: '',
            concon_id_pai: ''}),
        fields: [],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
   }
},
watch: {
    statusSelected(obj) {
        this.form.status = obj.value;
    },
    tpContaSelected(obj) {
        this.form.tp_conta = obj.value;
    },
    tpOperacaoSelected(obj) {
        this.form.tp_operacao = obj.value;
    },
    conconPaiSelected(obj) {
        this.form.concon_id_pai = obj.value;
    }
},
mounted() {
    this.getLivGeral();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.segurado_id);
        }
    },
    onCreate() {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Cadastrar";
        this.modal_botao = "Cadastrar";
        this.modal_acao = "i";
        this.form.reset();
        this.errors_array = '';
        this.errors_array = [];
        this.statusSelected = [];
        this.tpOperacaoSelected = [];
        this.tpContaSelected = [];
        this.conconPaiSelected = [];
        this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.errors_array = '';
        this.errors_array = [];
        this.statusSelected = [];
        this.tpOperacaoSelected = [];
        this.tpContaSelected = [];
        this.conconPaiSelected = [];
        this.form.cd = data.cd;
        this.form.descr = data.descr;
        this.statusSelected = { label: data.status.descr, value: data.status.valor };
        this.tpOperacaoSelected = { label: data.tipo_operacao.descr, value: data.tipo_operacao.valor };
        this.tpContaSelected = { label: data.tipo_conta.descr, value: data.tipo_conta.valor };
        this.conconPaiSelected = { label: data.descr, value: data.concon_id };

        this.form.segurado_id = id;
        this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    getLivGeral() {
        this.helpForm.get('/api/contacontabil/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
            })
            response.tp_conta.forEach((obj)=>
            {
                this.optionsLivTipoConta.push({ label: obj.descr, value: obj.valor })
            })
            response.tp_operacao.forEach((obj)=>
            {
                this.optionsLivTipoOperacao.push({ label: obj.descr, value: obj.valor })
            })
            response.conta_contabil.forEach((obj)=>
            {
                this.optionsLivConconPai.push({ label: obj.descr, value: obj.concon_id })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },

    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
